
import { LOGIN_PATH, SIGNUP_PATH } from '~/utils/constants'
export default {
  data () {
    return {
      SIGNUP_PATH,
      LOGIN_PATH
    }
  },
  computed: {
    isLoginPath () {
      return this.$route.path === LOGIN_PATH || this.$route.path === `${LOGIN_PATH}/`
    },
    isSignupPath () {
      return this.$route.path === SIGNUP_PATH || this.$route.path === `${SIGNUP_PATH}/`
    }
  }
}
